import { page, flags, breakpoints } from "../store"
import { Emitter } from "./"
import debounce from "lodash.debounce"
import { Sniffer, getWindowSizes, getViewport, setViewportHeight } from "../utils"
import { ScrollTrigger } from "../libraries/gsap"

export default class Resize {
  constructor() {
    this.isDesktop = Sniffer.isDesktop
    this.init()
  }

  onResize = () => {
    Object.assign(flags, { isResizing: true })
    const { width, height } = getViewport()
    const { XS, S, S_UP, M, M_UP } = getWindowSizes()
    Sniffer.update()
    this.reload()

    Object.assign(page, {
      vw: width,
      vh: height,
    })

    Object.assign(breakpoints, {
      xsmallDown: XS,
      smallDown: S,
      smallUp: S_UP,
      mediumDown: M,
      mediumUp: M_UP,
    })

    this.updateBodyClass()
    this.updateVH()
    Emitter.emit("resize")
    Object.assign(flags, { isResizing: false })
  }

  reload() {
    if (this.isDesktop !== Sniffer.isDesktop) {
      location.reload()
    }
  }

  updateVH = () => {
    document.documentElement.style.setProperty("--vh", `${page.vh}px`)
  }

  updateBodyClass() {
    const { vw, vh } = page
    const orientationClass = vw > vh ? "is-landscape" : "is-portrait"
    const desktopClass = Sniffer.isDesktop ? "is-desktop" : "is-device"
    document.body.classList.add(orientationClass)
    document.body.classList.add(desktopClass)
  }

  on() {
    window.addEventListener("resize", debounce(this.onResize, 200))
  }

  init() {
    this.on()
    this.onResize()
    setViewportHeight(page.vh)
  }
}
